module.exports = __webpack_public_path__ + "static/media/lf-light-triange.6d03b002.svg";